import ff from './ff';

export default class i16d { // 設備情報

static d_defs = {

/*
  DROP TABLE t_i16r;
  CREATE TABLE t_i16r (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER, 
    i16rb21f INTEGER,
    i16rc11s TEXT,
    i16rc31s TEXT,
    i16rcx1i INTEGER,
    i16rcy1t TEXT,
    i16rcy1f INTEGER,
    i16rcz1i INTEGER
  );
  INSERT INTO t_i16r (_vsn, _ltt, i16rb21f, i16rc11s, i16rc31s, i16rcx1i, i16rcy1t, i16rcy1f, i16rcz1i)
  VALUES (1, 1, 1, '100', '事業・運営', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i16r (_vsn, _ltt, i16rb21f, i16rc11s, i16rc31s, i16rcx1i, i16rcy1t, i16rcy1f, i16rcz1i)
  VALUES (1, 1, 1, '210', '文芸・歴史', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i16r (_vsn, _ltt, i16rb21f, i16rc11s, i16rc31s, i16rcx1i, i16rcy1t, i16rcy1f, i16rcz1i)
  VALUES (1, 1, 1, '220', '政治・経済', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_i16r (_vsn, _ltt, i16rb21f, i16rc11s, i16rc31s, i16rcx1i, i16rcy1t, i16rcy1f, i16rcz1i)
  VALUES (1, 1, 1, '230', '宗教・哲学', 9999, '2000-01-01 00:00:00', 1, 10);
  UPDATE t_i16r SET _fst = _key;
*/

  i16r: {
    0: {
      pfx: 'ジャンル',
      b_vsn: true,
      d_insFlds: {
        i16rb21f: -1,
        i16rb51f: -1,
        i16rc11s: '',
        i16rc31s: '',
        i16rt11i: -1,
        i16ri11i:  1,
        i16ri11m:  0,
      },
      dd_fldDefss: {
        i16rb21f: { 
          pfx: 'c20m_fst',
          type: 'Inp',
        },
        i16rc11s: {
          pfx: 'カテゴリID',
          type: 'Inp',
          n_col: 4,
        },
        i16rc31s: {
          pfx: 'カテゴリ名',
          type: 'Inp',
          n_col: 15,
        },
      },
    },
  },

};

};
